var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHNRacZmL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 6,
    viewBox: "0 0 5 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2593FF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5H3.786V1.5H.5zM.5 4.5H3.786V5.5H.5z",
    transform: "translate(-1028.000000, -817.000000) translate(1022.000000, 812.000000) translate(6.000000, 5.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHNRacZmL);
export default __webpack_public_path__ + "static/media/hNRacZmL.31b28dae684742370d5a574327ff86e5.svg";
export { ForwardRef as ReactComponent };